import React from 'react';
import './Tools.css';
import { useLanguage } from '../../context/LanguageContext';

// Imagens dos cards
import amiactiveImg from '../../images/tools/amiactive.png';
import molpredictxImg from '../../images/tools/molpredictx.png';
import sistematxImg from '../../images/tools/sistematx2.webp';

// Ícones para os títulos e subtítulos
import toolsIcon from '../../images/icons/tools.png';           // Ícone para o título "Tools"
import predictiveIcon from '../../images/icons/predictivetools.png'; // Ícone para "Predictive models"
import databaseIcon from '../../images/icons/database.png';       // Ícone para "Databases"

function Tools() {
  const { t } = useLanguage();  // Usa o contexto para traduzir títulos e textos do botão de DOI

  return (
    <main className="tools-container">
      {/* Título principal ajustado para 28px com ícone à direita */}
      <h1 className="tools-title">
        {t('toolsTitle')}
        <img src={toolsIcon} alt="Tools Icon" className="title-icon" />
      </h1>

      {/* Texto introdutório */}
      <p className="tools-intro">
        {t('toolsIntro1')}
      </p>
      <p className="tools-intro">
        {t('toolsIntro2')}
      </p>

      {/* Área com fundo #fafafa */}
      <div className="tools-bg">
        {/* Seção Predictive Models com ícone à direita (subtítulo em 22px) */}
        <section className="tools-section">
          <h2 className="tools-section-title">
            {t('toolsPredictiveModelsTitle')}
            <img src={predictiveIcon} alt="Predictive Models Icon" className="section-icon" />
          </h2>

          <div className="tools-cards">
            {/* Card 1: AmiActive */}
            <div className="tool-card">
              <a
                href="https://amiactive.ccen.ufpb.br/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={amiactiveImg}
                  alt="AmiActive Logo"
                  className="tool-logo"
                />
              </a>
              <h3 className="tool-card-title">{t('toolsAmiActiveTitle')}</h3>
              <p className="tool-card-desc">{t('toolsAmiActiveDesc')}</p>
            </div>

            {/* Card 2: Molpredictx */}
            <div className="tool-card">
              <a
                href="https://www.molpredictx.ufpb.br/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={molpredictxImg}
                  alt="Molpredictx Logo"
                  className="tool-logo"
                />
              </a>
              <h3 className="tool-card-title">{t('toolsMolPredictxTitle')}</h3>
              <p className="tool-card-desc">{t('toolsMolPredictxDesc')}</p>
            </div>
          </div>
        </section>

        {/* Seção Databases com ícone à direita */}
        <section className="tools-section">
          <h2 className="tools-section-title">
            {t('toolsDatabasesTitle')}
            <img src={databaseIcon} alt="Database Icon" className="section-icon" />
          </h2>

          <div className="tools-cards">
            {/* Card: SistematX */}
            <div className="tool-card">
              <a
                href="https://sistematx.ufpb.br/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={sistematxImg}
                  alt="SistematX Logo"
                  className="tool-logo"
                />
              </a>
              <h3 className="tool-card-title">{t('toolsSistematxTitle')}</h3>
              <p className="tool-card-desc">{t('toolsSistematxDesc')}</p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Tools;
